import { useQuery } from "@tanstack/react-query";
import { getDecizieNivelRisc } from "@/api/endpoints/decizieNivelRisc";
import { queryKeys } from "@/lib/queryClient";

export function useGetDecizieNivelRisc(
  sessionId: string | null,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: queryKeys.decizieNivelRisc.bySession(sessionId ?? ""),
    queryFn: () => getDecizieNivelRisc(sessionId!),
    enabled: (options?.enabled ?? true) && !!sessionId,
    retry: false,
  });
}
